import { getNewComparisonGroup, getAvailableGroup, generateSankeyData } from "../components/Reports/CTSAReport/CTSAReportHelper";
import { arrayToCsv } from "../components/Common/Helpers";
import { authHeader } from '../javascript/auth-header';
import { store } from "../store";
import { push } from 'connected-react-router'
import { LinkStuff } from '../interface/MyInterfaces';
import { handleReportDisplayIdChange_CTSAReport, authenticateUserOutsideLogin, loadUniversityList_CTSAReport } from './UserActions';
import JSZip from "jszip";
import { saveAs } from 'file-saver';



export function changeComparisonGroup(e) {
    const { comparisonGroup } = store.getState().CTSAReportProperties;
    return {

        type: "CHANGE_COMPARISON_GROUP", payload: getNewComparisonGroup(comparisonGroup, e.target.value)
    }
}


export function hydrateComparisonGroup(availableGroup) {
    return {

        type: "CHANGE_COMPARISON_GROUP", payload: availableGroup
    }
}

export function loadAwardTotal(display_id) {
    return dispatch => {
        let url = `/IRISReportsMicroservice/api/CTSAReport/award-total/${display_id} `;
        
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_AWARD_TOTAL",
                    payload: json
                });

            })
    };
}

export function loadAvailableGroup(display_id) {
    return dispatch => {
        let url = `/IRISReportsMicroservice/api/CTSAReport/award-total/${display_id} `;
        
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_AVAILABLE_GROUP",
                    payload: getAvailableGroup(json)
                });

            })
    };
}


export function loadCareerData(display_id) {
    return dispatch => {
        let url = `/IRISReportsMicroservice/api/CTSAReport/career/${display_id} `;
        
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_CAREER_DATA",
                    payload: json
                });
            });
    };
}

export function loadAwardData(display_id, outcome_award) {
    return dispatch => {
        let url = `/IRISReportsMicroservice/api/CTSAReport/award/${display_id}/${outcome_award} `;
        
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_AWARD_DATA",
                    payload: json
                });
            });

    }
}

export function loadPatentNumber(display_id) {
    return dispatch => {
        let url = `/IRISReportsMicroservice/api/CTSAReport/patent-number/${display_id} `;
        
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_PATENT_NUMBER",
                    payload: json
                });
            });
    };
}

export function loadPatentSector(display_id) {
    return dispatch => {
        let url = `/IRISReportsMicroservice/api/CTSAReport/patent-sector/${display_id} `;
        
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_PATENT_SECTOR",
                    payload: json
                });
            });
    };
}


export function loadBibs(display_id) {
    return dispatch => {
        let url = `/IRISReportsMicroservice/api/CTSAReport/biblometrics/${display_id} `;
        
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_BIBS",
                    payload: json
                });
            });
    };
}

export function loadJournals(display_id) {
    return dispatch => {
        let url = `/IRISReportsMicroservice/api/CTSAReport/journals/${display_id} `;
        
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_JOURNALS",
                    payload: json
                });
            })
    };
}

export function loadMeshTerms(display_id, comparisonGroup, rankDifference = 15) {
    let url = `/IRISReportsMicroservice/api/CTSAReport/mesh/${display_id}/`;
    if (comparisonGroup.length === 0) {
        url += `null/${rankDifference}`;
    } else {
        url += `${comparisonGroup.join(",")}/${rankDifference} `;
    }
    return dispatch => {
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_MESHTERMS",
                    payload: json
                });
            });
    };
}


export function loadAwardPathway(display_id) {
    return dispatch => {
        let url = `/IRISReportsMicroservice/api/CTSAReport/award-pathway/${display_id} `;
        
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_AWARD_PATHWAY",
                    payload: json
                });
            });
    };
}


export function loadKL2ModalPath(display_id) {
    return dispatch => {
        let url = `/IRISReportsMicroservice/api/CTSAReport/kl2-modal-path/${display_id} `;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_KL2_MODALPATH",
                    payload: json
                });
            });
    };
}

export function loadTeam(display_id) {
    return dispatch => {
        let url = `/IRISReportsMicroservice/api/CTSAReport/team/${display_id} `;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_TEAM",
                    payload: json
                });
            });
    };
}

export function loadTeamGender(display_id) {
    return dispatch => {
        let url = `/IRISReportsMicroservice/api/CTSAReport/team-gender/${display_id} `;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_TEAM_GENDER",
                    payload: json
                });
            });
    };
}


export function loadMethodMatch(display_id) {
    return dispatch => {
        let url = `/IRISReportsMicroservice/api/CTSAReport/match/${display_id} `;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_METHODOLOGY_MATCH",
                    payload: json
                });
            });
    };
}

function move(arr, old_index, new_index) {
    while (old_index < 0) {
        old_index += arr.length;
    }
    while (new_index < 0) {
        new_index += arr.length;
    }
    if (new_index >= arr.length) {
        var k = new_index - arr.length;
        while ((k--) + 1) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
}

export function loadMethodGroup(display_id) {
    return dispatch => {
        let url = `/IRISReportsMicroservice/api/CTSAReport/comp-group/${display_id} `;
        
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                
                var index = json.findIndex(obj => obj.study_award == "KL2");
                
                var meth = move(json, index, 0);
                dispatch({
                    type: "GET_METHODOLOGY_GROUP",
                    payload: meth
                });
            });
    };
}




export function shareCTSAReport(link_id, p1, p2) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SharedLink/report_link/" + link_id + "/" + p1 + "/" + p2;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(async function (json) {
                var link: LinkStuff = json;
                if (link.link_id == -1) {
                    dispatch({
                        type: "BAD_LINK",
                        payload: json
                    });
                    dispatch(push('/reports/bad_link'));
                } else {
                    await authenticateUserOutsideLogin();

                    const displayId = /agg/g.test(link.report_type) ? '-1' : link.display_id;
                    dispatch(handleReportDisplayIdChange_CTSAReport({ value: displayId }));
                    dispatch(loadUniversityList_CTSAReport())
                    dispatch(loadAwardTotal(displayId));
                    dispatch(loadAvailableGroup(displayId));
                    dispatch(loadCareerData(displayId));
                    dispatch(loadPatentNumber(displayId));
                    dispatch(loadPatentSector(displayId));
                    dispatch(loadBibs(displayId));
                    dispatch(loadJournals(displayId));
                    dispatch(loadAwardData(displayId, 'R01'));
                    dispatch(loadAwardPathway(displayId));
                    dispatch(loadKL2ModalPath(displayId));
                    dispatch(loadTeam(displayId));
                    dispatch(loadTeamGender(displayId));
                    dispatch(loadMethodGroup(displayId));
                    dispatch(loadMethodMatch(displayId));
                }
            });
    };
}


export function downloadCTSAData(CTSAReportState) {
    const { awardTotal, comparisonGroup, awardPathway, awardData, careerData, bibs, journals, patentNumber, patentSector, mesh, team, teamGender } = CTSAReportState;

    const careerCsv = arrayToCsv({ data: careerData });
    const awardTotalCsv = arrayToCsv({ data: awardTotal });
    const bibsCsv = arrayToCsv({ data: bibs });
    const journalsCsv = arrayToCsv({ data: journals });
    const patentNumCsv = arrayToCsv({ data: patentNumber });
    const patentSectorCsv = arrayToCsv({ data: patentSector });
    const meshCsv = arrayToCsv({ data: mesh });
    const R01Csv = arrayToCsv({ data: awardData });


    const sankeyData = generateSankeyData(awardPathway, comparisonGroup);
    const { nodes, links } = sankeyData;
    const pathwayCsv = arrayToCsv({
        data:
            links.map(link => ({
                source: nodes.filter(node => node.id === link.source)[0].name,
                target: nodes.filter(node => node.id === link.target)[0].name,
                n: link.value < 5 ? 'masked' : link.value
            }))
    });
    const teamGenderCsv = arrayToCsv({ data: teamGender })

    const teamArr = team.map(o => {
        if (o.study_award !== 'KL2') {
            if (o.n_scholars < 5) {
                return { ...o, scholars_with_any_in_class: "masked", total_employed_in_class: "masked" }
            }
        }
        return o;

    })

    const teamCsv = arrayToCsv({ data: teamArr });
    const zip = new JSZip();
    zip.file('onGoingCareer.csv', careerCsv);
    zip.file("awardTotal.csv", awardTotalCsv);
    zip.file("biblometrics.csv", bibsCsv);
    zip.file("journals.csv", journalsCsv);
    zip.file("patentNumber.csv", patentNumCsv);
    zip.file("patentSector.csv", patentSectorCsv);
    zip.file("R01Attainment.csv", R01Csv);
    zip.file("MeSHTerms.csv", meshCsv);
    zip.file("NIHPathway.csv", pathwayCsv);
    zip.file("teamGender.csv", teamGenderCsv);
    zip.file("teamComposition.csv", teamCsv);

    zip.generateAsync({ type: "blob" })
        .then(function (blob) {
            saveAs(blob, "CTSAReportData.zip");
        });


    return { type: 'DOWNLOAD' }


}